import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

interface CreditAnalysisConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (verifyCredit: boolean) => void;
  loading?: boolean;
}

const CreditAnalysisConfirmDialog: React.FC<CreditAnalysisConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const handleConfirm = (verifyCredit: boolean) => {
    onConfirm(verifyCredit);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <HelpOutline color="primary" />
          <Typography variant="h6" component="span">
            Análise de Crédito
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Deseja enviar este pedido para análise de crédito?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          A análise de crédito pode ser necessária para validar a elegibilidade do cliente antes de
          processar o pedido.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button onClick={onClose} color="inherit" disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={() => handleConfirm(false)}
          variant="outlined"
          color="primary"
          disabled={loading}
        >
          Não, prosseguir sem análise
        </Button>
        <Button
          onClick={() => handleConfirm(true)}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          Sim, enviar para análise
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreditAnalysisConfirmDialog;
